<div class="slider-container" [style.background-image]="brand.id ? 'url(' + brand.registrationBgPath + ')' : null">
     <div class="background-for-registration" [style.background-image]="brand.id ? 'url(' + brand.registrationBgPath + ')' : null">
    <div class="bluewings-string-logo">
        <img *ngIf="brand.id" [src]="brand.stringLogoPath" alt="logo" class="blw-logo">
    </div>
    <div class="container-sub-bg">
        <div class="slideshow-container">
            <div class="mySlides fade">
                <div class="image-container-slider">
                    <img src="../../assets/img/sub_background.png" class="sub-bg-img-first">
                </div>
                <div class="about-registration-page">
                    {{'visualise' | translate}}<br> {{'dataMessage' | translate}}
                </div>
            </div>
            <div class="mySlides fade">
                <div class="image-container-slider">
                    <img src="../../assets/img/slider_second.png" class="sub-bg-img">
                </div>
                <div class="about-registration-page">
                    {{'plan' | translate}}<br>{{'publish' | translate}}
                </div>
            </div>
            <div class="mySlides fade">
                <div class="image-container-slider">
                    <img src="../../assets/img/slider_third.png" class="sub-bg-img">
                </div>
                <div class="about-registration-page">
                    {{'seamless' | translate}} <br>{{'userFriendly' | translate}}
                </div>
            </div>
        </div>
    </div>
    <div class="dot-container">
        <span class="dot"></span>
        <span class="dot"></span>
        <span class="dot"></span>
    </div>
</div>
</div>